'use client';

import { useRef } from 'react';
import SEO from '~/components/shared/SEO';
import Editor from '~/components/shared/MarkdownEditor';

/*
const Editor = dynamic(() => import('../../../../components/shared/MarkdownEditor'), {
  ssr: false,
});
 */

export default function Page() {
  const editorRef = useRef<any>(null);

  return (
    <>
      <SEO
        title={`Markdown Editor | Content Flywheel`}
        description={`Craft compelling content with ease! Our Markdown editor simplifies writing & formatting for web & beyond. Try it free & unleash your writing power!`}
        url={`https://www.contentflywheel.com/tools/markdown-editor`}
        keywords={["Content Flywheel", "Markdown Editor", "Markdown", "Content Editor", "Content Writing", "Content Creation", "Content Repurposing"]}
      />
      <div className="flex justify-center overflow-x-hidden">
        <div className="flex flex-col items-center w-full max-w-screen-3xl min-h-[500px] p-4 md:p-10">
          <h1 className="font-heading text-4xl font-bold text-center mb-4">
            Markdown Editor
          </h1>
          <div>
            <p className="text-center mb-10 lg:w-2/3 mx-auto text-muted-foreground">
              Tired of clunky formatting options and messy code? Unleash your
              writing power with our intuitive Markdown editor. Focus on your
              ideas, not the markup, with simple symbols that transform into
              headings, bold text, and more. Write with confidence, knowing
              your content will look stunning on any platform. Whether you&apos;re
              crafting blog posts, creating stunning documentation, or simply
              jotting down ideas, our editor makes writing a breeze!
            </p>
          </div>
          <div className="w-full lg:w-2/3 pb-20">
            <Editor editorRef={editorRef} markdown={`# Hello 👋`} />
          </div>
        </div>
      </div>
    </>
  );
}
